import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { materialSymbols } from '../../../shared/constants/material-symbols';


export interface IFileUpload {
  files: File[];
  hasError: boolean;
}

@Component({
    selector: 'files-upload',
    templateUrl: './files-upload.component.html',
    styleUrl: './files-upload.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FilesUploadComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class FilesUploadComponent implements ControlValueAccessor{

  @Input() title: string = "";
  @Input() multiple: boolean = false;
  @Input() progress: number[] = [100];
  @Input() accept: string = ".pdf";
  @Input() maxSizeInMg: number = 25;

  isDisabled: boolean = false;
  onChange: (value: IFileUpload) => void = () => {};
  onTouched: any = () => { };

  @Output() onFilesUpload: EventEmitter<IFileUpload> = new EventEmitter<IFileUpload>();

  upload = materialSymbols.upload;
  folderOpen = faFolderOpen;
  draft = materialSymbols.draft;
  close = materialSymbols.close;

  isDragging: boolean = false;
  hasError: boolean[] = [];

  files: File[] = [];

  constructor(
  ) {
  }

  writeValue(obj: any): void {

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onFileSelected(event: any) {
    if(this.multiple)
      this.files = [...this.files, ...event.target.files];
    else
      this.files = [event.target.files[0]]

    let isValid = this.validate();

    const newValue: IFileUpload = {
      files: this.files,
      hasError: !isValid
    };
    this.onFilesUpload.emit(newValue);
    this.onChange(newValue);
  }

  onDragOver(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  onDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (this.multiple)
      this.files = [...this.files, ...Array.from(e.dataTransfer?.files??[])];
    else if(e.dataTransfer?.files[0])
      this.files = [e.dataTransfer?.files[0]];

    if (!this.files) return;

    let isValid = this.validate();

    const newValue: IFileUpload = {
      files: this.files,
      hasError: !isValid
    };
    this.onFilesUpload.emit(newValue);
    this.onChange(newValue);

    this.isDragging = false;
  }

  onDelete(e: any) {
    this.files.splice(Number(e.target?.id), 1);

    const newValue: IFileUpload = {
      files: this.files,
      hasError: false
    };
    this.onFilesUpload.emit(newValue);
    this.onChange(newValue);
  }

  validate() {
    let acceptList: string[] = this.accept.replaceAll('.','').trim().split(',');
    let isValid = true;
    this.files.forEach((file, index) => {
      let type = "";
      if(file?.name)
        type = file?.name.split('.')?.pop()??"";

      if(!acceptList.includes(type)) {
        this.hasError[index] = true;
        isValid = false;

      }
      else if(this.convertByteToMegaByte(file?.size) > this.maxSizeInMg) {
        this.hasError[index] = true;
        isValid = false;
      }
      else {
        this.hasError[index] = false;
      }
    });

    return isValid;

  }

  convertByteToMegaByte(value: number) {
    let v = ((value??0) / 1000000);
    return v;
  }

}
